import { TranslatorContext } from 'react-jhipster';
import { ACTION_TYPES } from './store/locale.actions';
import { localeApi } from '../api';

export const setLocale = locale => async dispatch => {
  if (!Object.keys(TranslatorContext.context.translations).includes(locale)) {
    const response = await localeApi.setLocale(locale);
    TranslatorContext.registerTranslations(locale, response.data);
  }
  dispatch({
    type: ACTION_TYPES.SET_LOCALE,
    locale
  });
};
